import { createApp } from "vue";
import App from "./App.vue";
import router, { historyStack } from './router';
import { FontAwesomeIcon } from "./plugins/font-awesome";
import { LoadingPlugin } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import i18n from './i18n';
import VueSimpleAlert from "vue3-simple-alert";
import 'sweetalert2/dist/sweetalert2.min.css';
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// CSS
import "./assets/css/custom.css";
import "./assets/css/tooltip.css";

const app = createApp(App)
    .use(router)
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(LoadingPlugin, {
        color: '#9F0000',
    })
    .use(i18n)
    .use(VueSimpleAlert);

app.config.globalProperties.navigateBackOrHome = function () {
    const currentRoute = this.$route.fullPath;

    // Check if we can actually go back to a different page
    const lastVisitedRoute = historyStack.length > 1 ? historyStack[historyStack.length - 2] : null;

    if (lastVisitedRoute && lastVisitedRoute !== currentRoute) {
        this.$router.go(-1);  // Navigate back
    } else {
        this.$router.push({ name: 'Home' });  // Navigate to home
    }
};
app.config.globalProperties.appName = process.env.VUE_APP_NAME || 'Dani Andhika Permana';
app.config.globalProperties.$vueAlert = VueSimpleAlert;

app.mount("#app");
